import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Heart, Award } from 'lucide-react';
import { Footer } from '../components/Footer';

export const LandingPage = () => {
  return (
    <div className="min-h-screen bg-gray-950 flex flex-col">
      {/* Logo */}
      <div className="text-center pt-12 pb-6">
        <h1 className="text-3xl font-bold text-white tracking-tight">PUSH Training - NC</h1>
        <p className="text-gray-400 mt-1 text-sm">Choose where you'd like to go</p>
      </div>

      {/* Two Choices */}
      <div className="flex-1 flex flex-col md:flex-row gap-0">
        {/* CPR / BLS Side */}
        <Link
          to="/home"
          className="flex-1 group relative overflow-hidden bg-gradient-to-br from-red-700 to-red-900 flex flex-col items-center justify-center p-12 md:p-16 transition-all duration-300 hover:from-red-600 hover:to-red-800 min-h-[45vh] md:min-h-0"
        >
          <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-10 transition-opacity" />
          <div className="relative text-center">
            <div className="w-20 h-20 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-white/20 transition-colors">
              <Heart className="text-white" size={40} fill="currentColor" />
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">CPR & BLS Training</h2>
            <p className="text-red-100 text-lg md:text-xl max-w-sm mx-auto mb-8">
              AHA-certified CPR, First Aid, and BLS classes for individuals and organizations.
            </p>
            <div className="inline-flex items-center gap-2 bg-white text-red-700 font-bold px-8 py-4 rounded-full text-lg group-hover:bg-red-50 transition-colors">
              Enter CPR Training <ArrowRight size={20} />
            </div>
          </div>
        </Link>

        {/* Divider */}
        <div className="hidden md:flex items-center justify-center w-12 bg-gray-950 flex-shrink-0">
          <div className="w-px h-3/4 bg-gray-700" />
          <span className="absolute text-gray-600 text-xs font-bold bg-gray-950 px-2 py-1">OR</span>
        </div>
        <div className="md:hidden flex items-center justify-center h-8 bg-gray-950">
          <div className="h-px w-3/4 bg-gray-700" />
          <span className="absolute text-gray-600 text-xs font-bold bg-gray-950 px-2">OR</span>
        </div>

        {/* Certification Prep Side */}
        <Link
          to="/prep"
          className="flex-1 group relative overflow-hidden bg-gradient-to-br from-blue-700 to-blue-900 flex flex-col items-center justify-center p-12 md:p-16 transition-all duration-300 hover:from-blue-600 hover:to-blue-800 min-h-[45vh] md:min-h-0"
        >
          <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-10 transition-opacity" />
          <div className="relative text-center">
            <div className="w-20 h-20 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-white/20 transition-colors">
              <Award className="text-white" size={40} />
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">Certification Prep</h2>
            <p className="text-blue-100 text-lg md:text-xl max-w-sm mx-auto mb-8">
              Structured study tools and guidance to help you pass your Allied Health certification exams.
            </p>
            <div className="inline-flex items-center gap-2 bg-white text-blue-700 font-bold px-8 py-4 rounded-full text-lg group-hover:bg-blue-50 transition-colors">
              Enter Certification Prep <ArrowRight size={20} />
            </div>
          </div>
        </Link>
      </div>

      {/* Legal */}
      <div className="text-center py-4 bg-gray-950">
        <p className="text-gray-600 text-xs max-w-2xl mx-auto px-4">
          PUSH Training - NC provides certification preparation and educational support. We do not issue certifications. Certification is obtained through accredited testing organizations.
        </p>
      </div>
      <Footer />
    </div>
  );
};
